if (!window.Eurus.loadedScript.has('tab-attention.js')) {
  window.Eurus.loadedScript.add('tab-attention.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xTabAttention', ({ pairs, delay }) => ({
        // each pair = [hook, payoff]; keep only non-empty beats
        pairs: (Array.isArray(pairs) ? pairs : [])
          .map((p) => (Array.isArray(p) ? p : [p]).filter(Boolean))
          .filter((p) => p.length),
        queue: [],
        queueIndex: 0,
        intervalId: null,
        pageTitle: document.title,

        init() {
          document.title = this.pageTitle;
          if (this.pairs.length === 0) {
            return;
          }
          window.addEventListener('focus', this.handleStopTabAttention.bind(this));
          window.addEventListener('blur', this.handleStartTabAttention.bind(this));
        },

        // shuffle the pairs, then flatten into a beat sequence (hook, payoff, hook, payoff, ...)
        buildQueue() {
          const shuffled = this.pairs.slice();
          for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            const tmp = shuffled[i];
            shuffled[i] = shuffled[j];
            shuffled[j] = tmp;
          }
          this.queue = shuffled.reduce((acc, p) => acc.concat(p), []);
          this.queueIndex = 0;
        },

        showNext() {
          if (this.queueIndex >= this.queue.length) {
            this.buildQueue();
          }
          document.title = this.queue[this.queueIndex];
          this.queueIndex++;
        },

        handleStartTabAttention() {
          if (this.intervalId) return;
          this.buildQueue();
          this.showNext();
          this.intervalId = setInterval(() => this.showNext(), delay * 1000);
        },

        handleStopTabAttention() {
          if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
          }
          document.title = this.pageTitle;
        },
      }));
    });
  });
}
